import { useState, useEffect } from 'react'
import Select from 'react-select'
import { ExclamationCircleIcon } from '@heroicons/react/solid'
import axios from 'axios';

// Axios
axios.defaults.baseURL = process.env.REACT_APP_API_ENDPOINT
axios.defaults.withCredentials = true

export default function RoleMultiselectField(props) {
    const { label, description = null, input, meta, col = 3, required = false } = props
    const [isLoaded, setIsLoaded] = useState(false);
    const [items, setItems] = useState([])
    const updatedSelectedItems = (items) => { 
        if(items.length) {
            return items.map((item) => ({ label: item.name, value: item.id, ...item }));
        }
        return [];
    }
    const [selectedItems, setSelectedItems] = useState(updatedSelectedItems(input.value))

    useEffect(() => {
        // Get user detail
        axios.get('/select/roles')
            .then(function (response) {
                //console.log(response.data)
                setItems(response.data.data)
                setIsLoaded(true);
            })
            .catch(function (error) {
            // handle error
            //setIsLoaded(true);
            //setError(error);
            })
            .then(function () {
            //setIsLoaded(true);
            });    
    }, [])


    function handleChange(value)
    {
        input.onChange(value)
    }

    if(isLoaded) {
        return (
            <div className={'sm:col-span-'+col}>
                <div className="flex justify-between">
                    <label htmlFor={input.name} className="block text-sm font-medium text-gray-700">
                        {label} {required && <span className="text-red-500">*</span>}
                    </label>
                    {description && <span className="text-sm text-gray-500">{description}</span>}
                </div>
                <div className="mt-1 relative rounded-md shadow-sm">
                    <Select
                        classNamePrefix="react-select"
                        defaultValue={selectedItems} 
                        isMulti
                        options={items} 
                        className="basic-multi-select"
                        onChange={handleChange}
                    />
                    {meta.error && meta.touched && <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                        <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true" />
                    </div>}
                </div>
                {meta.error && meta.touched && <p className="mt-2 text-sm text-red-600">{meta.error}</p>}
            </div>
        )
    }
}
